import * as net from 'util/Net';

export function runAlphaFold(proteinId: string): Promise<void> {
  return net.postJSONPromise({url: '/1/api/aa-sequences:alphafold', data: {proteinId}});
}

export function runStructurePrediction(
  proteinIds: Array<string>,
  moleculeIds: Array<string>,
  model: string
): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/aa-sequences:structure-prediction',
    data: {proteinIds, moleculeIds, model},
  });
}
